import React, {useEffect, useState} from "react";
import "./EventPage.css"
import {Form} from "../../components/Form/Form";
import {useParams} from "react-router-dom";
import {languageManager} from "../../utils/i18n";
import {fetchGoogleSheetData} from "../../services/google";

const EventPage = () => {
	const t = key => languageManager.t(key);
	const id = useParams().id;
	const [canSubmit, setCanSubmit] = useState(true);
	const [data, setData] = useState(null)

	const isPast = data?.startsAt ? data.startsAt.getTime() <= Date.now() : false;

	useEffect(() => {
		fetchGoogleSheetData()
			.then(r => {
				const event = r?.find(item => item?.url.split("/event/")[1] === id)
				setData(event)
			})
	}, [id]);

	return (
		<div className="event_page">
			<div className="event_container">
				{data &&
					<>
						{isPast ?
							<div className="overlimit">
								<span>{t("event.past.title")}</span>
								<p>{t("event.past.subtitle")}</p>
							</div>
							: canSubmit ?
								<div className='event_form__container'>
									<Form id={id} canSubmit={canSubmit} setCanSubmit={setCanSubmit} event={data} className='event_form'/>
								</div>
								:
								<div className="overlimit">
									<span>{t("event.overlimit.title")}</span>
									<p>{t("event.overlimit.subtitle")}</p>
								</div>
						}
					</>
				}
			</div>
		</div>
	);
};

export default EventPage;